







































































































































































import { setDetail, courseSpecList, createSet, editSet } from "@/api/course";
import { solveLargeNumber } from "@/utils/common";
import courseDialog from "./courseDialog.vue";
import { Vue, Component } from "vue-property-decorator";
@Component({
  name: "storeSetDetail",
  components: {
    courseDialog,
  },
})
export default class extends Vue {
  setDetailForm: any = {
    combo_product_id: 0,
    name: "",
    remark: "",
    price: 0,
    item: [],
  };
  setDetailFormCache: string = "";
  courseSpecObj: any = {};
  allSpecObj: any = {};
  rules = {
    name: [{ required: true, message: "请输入套餐名称", trigger: "blur" }],
  };
  blurStatus: boolean = true;
  created() {
    const id = Number(this.$route.query.id);
    if (id !== 0) {
      // 编辑
      setDetail({ combo_product_id: id }).then((res: any) => {
        if (res.error_code === 0) {
          this.setDetailForm = {
            combo_product_id: res.data.combo_product_id,
            name: res.data.name,
            remark: res.data.remark,
            price: Number(res.data.price), // 总价
            item: [],
          };
          res.data.item.map((item: any) => {
            courseSpecList({ course_id: item.product_id }).then(
              (result: any) => {
                if (result.error_code === 0) {
                  // 接口返回的quantity可能是spec_quantity为1的规格被修改后的数据，需要从规格列表里面找到原本的spec_quantity
                  let spec_quantity = 0;
                  result.data.list.map((j: any) => {
                    if (j.course_spec_id === item.spec_id) {
                      spec_quantity = Number(j.quantity);
                    }
                    this.allSpecObj[j.course_spec_id] = j;
                  });
                  this.courseSpecObj[item.product_id] = result.data.list;
                  const format = {
                    product_name: item.product_name,
                    type: item.item_type,
                    product_id: item.product_id,
                    spec_id: item.spec_id,
                    spec_quantity: Number(spec_quantity),
                    quantity: Number(item.quantity),
                    unit_price: Number(item.unit_price), // 规格单价，spec_quantity为1时配合quantity使用
                    price: Number(item.spec_price), // 规格总价，spec_quantity大于1时使用
                    discount_type: item.discount === 0 ? 1 : 2,
                    discount: item.discount,
                    discount_amount: Number(item.discount_amount),
                    item_id: item.item_id,
                    sum: Number(item.subtotal),
                  };
                  this.setDetailForm.item.push(format);
                  this.setDetailFormCache =
                    this.setDetailFormCache + JSON.stringify(format);
                  this.solveTableTotal();
                }
              }
            );
          });
        }
      });
    }
  }
  handleDeleteCourse(scope: any) {
    const copy = [...this.setDetailForm.item];
    copy.splice(scope.$index, 1);
    this.setDetailForm.item = copy;
    this.$nextTick(() => {
      this.solveTableTotal();
    });
  }
  solveSum(quantity: number, unit_price: number, discount_amount: number) {
    return (
      Math.ceil(
        (solveLargeNumber(quantity) * solveLargeNumber(unit_price) -
          solveLargeNumber(discount_amount) * 100) /
          100
      ) / 100
    );
  }
  solvePrice(quantity: number, unit_price: number) {
    return (
      Math.ceil(
        (solveLargeNumber(quantity) * solveLargeNumber(unit_price)) / 100
      ) / 100
    );
  }
  updateCourseTable(newArr: number[]) {
    const result: any[] = [...this.setDetailForm.item];
    Promise.all(
      newArr.map((cid: any) => {
        return new Promise((resolve) => {
          let specList;
          if (this.courseSpecObj[cid]) {
            specList = this.courseSpecObj[cid];
            resolve({
              product_name: specList[0].course_name,
              type: 1,
              product_id: specList[0].course_id,
              spec_id: specList[0].course_spec_id,
              spec_quantity: Number(specList[0].quantity),
              quantity: Number(specList[0].quantity),
              unit_price: Number(specList[0].unit_price),
              price: Number(specList[0].price),
              discount_type: 1,
              discount: 0,
              discount_amount: 0,
              sum: Number(specList[0].price),
            });
          } else {
            courseSpecList({ course_id: cid }).then((res: any) => {
              res.data.list.map((j: any) => {
                this.allSpecObj[j.course_spec_id] = j;
              });
              this.courseSpecObj[cid] = res.data.list;
              specList = res.data.list;
              resolve({
                product_name: specList[0].course_name,
                type: 1,
                product_id: specList[0].course_id,
                spec_id: specList[0].course_spec_id,
                spec_quantity: Number(specList[0].quantity),
                quantity: Number(specList[0].quantity),
                unit_price: Number(specList[0].unit_price),
                price: Number(specList[0].price),
                discount_type: 1,
                discount: 0,
                discount_amount: 0,
                sum: Number(specList[0].price),
              });
            });
          }
        });
      })
    ).then((res) => {
      const arr = [...result, ...res];
      this.setDetailForm.item = arr;
      this.$nextTick(() => {
        this.solveTableTotal();
      });
    });
  }
  handleRowChange(row: any) {
    if (row.discount_type === 1) {
      row.quantity = Number(row.quantity.toFixed(2));
      row.discount_amount = Number(Number(row.discount_amount).toFixed(2));
      if (Number(row.spec_quantity) === 1) {
        row.sum = Number(
          this.solveSum(row.quantity, row.unit_price, row.discount_amount)
        );
      } else {
        row.sum =
          (solveLargeNumber(row.price) -
            solveLargeNumber(row.discount_amount)) /
          100;
      }
      this.solveTableTotal();
    }
  }
  handleSumChange(row: any) {
    row.sum = Number(Number(row.sum).toFixed(2));
    if (row.discount_type === 1) {
      if (Number(row.spec_quantity) === 1) {
        row.discount_amount = this.solveSum(
          row.quantity,
          row.unit_price,
          row.sum
        );
      } else {
        row.discount_amount =
          (solveLargeNumber(row.price) - solveLargeNumber(row.sum)) / 100;
      }
    }
    this.solveTableTotal();
  }
  solveTableTotal() {
    const table: any = this.$refs.mainTable;
    if (table.data) {
      let res = 0;
      table.data.map((row: any) => {
        res = res + Number(row.sum);
      });
      this.setDetailForm.price = Number(res.toFixed(2));
    }
  }
  handleSubmit() {
    (this.$refs["mainForm"] as Vue & { validate: Function }).validate(
      (valid: boolean) => {
        if (valid) {
          // 判断表格完整性
          const table: any = this.$refs.mainTable;
          const tableData = table.data;
          if (tableData && tableData.length > 0) {
            let pass = true;
            let msg = "";
            tableData.map((item: any) => {
              if (typeof item.type !== "number" || item.type < 0) {
                pass = false;
                msg = "请选择套餐目录类型";
              }
              if (typeof item.product_id !== "number" || item.product_id < 0) {
                pass = false;
                msg = "请输入商品ID";
              }
              if (typeof item.spec_id !== "number" || item.spec_id < 0) {
                pass = false;
                msg = "请选择规格";
              }
              if (typeof item.quantity !== "number" || item.quantity < 1) {
                pass = false;
                msg = "购买数量不能为空或小于1";
              }
              if (
                typeof item.discount_type !== "number" ||
                item.discount_type < 0
              ) {
                pass = false;
                msg = "请选择优惠类型";
              }
              if (item.discount_type === 1) {
                if (
                  typeof item.discount_amount !== "number" ||
                  item.discount_amount < 0
                ) {
                  pass = false;
                  msg = "请正确填写直减数值";
                }
              }
              if (item.discount_type === 2) {
                if (typeof item.discount !== "number" || item.discount < 0) {
                  pass = false;
                  msg = "请正确填写折扣百分比";
                }
              }
              if (typeof item.sum !== "number" || item.sum < 0) {
                pass = false;
                msg = "请正确填写小计";
              }
            });
            if (!pass) {
              this.$message({
                type: "error",
                message: msg,
              });
              return false;
            }
          }
          const items: any[] = [];
          tableData.map((item: any) => {
            const params: any = {
              type: item.type,
              product_id: item.product_id,
              spec_id: item.spec_id,
              quantity: String(item.quantity),
              discount_type: item.discount_type === 1 ? 0 : 1,
              discount: String(
                item.discount_type === 1 ? item.discount_amount : item.discount
              ),
            };
            if (item.item_id) {
              params.item_id = item.item_id;
            }
            items.push(params);
          });
          // 发起请求
          const id = Number(this.$route.query.id);
          if (id !== 0) {
            // 编辑
            editSet({
              combo_product_id: id,
              name: this.setDetailForm.name,
              remark: this.setDetailForm.remark,
              item: items,
            }).then((res: any) => {
              if (res.error_code == 0) {
                this.$message({
                  type: "success",
                  message: "编辑成功!",
                });
                this.setDetailFormCache = this.setDetailForm.item
                  .map((item: any) => {
                    return JSON.stringify(item);
                  })
                  .join("");
              } else {
                this.$message({
                  type: "error",
                  message: "编辑失败!" + res.message,
                });
              }
            });
          } else {
            // 新增
            createSet({
              name: this.setDetailForm.name,
              remark: this.setDetailForm.remark,
              item: items,
            }).then((res: any) => {
              if (res.error_code == 0) {
                this.$message({
                  type: "success",
                  message: "新增成功!",
                });
                this.$router.push({
                  name: "storeCourse",
                });
              } else {
                this.$message({
                  type: "error",
                  message: "新增失败!" + res.message,
                });
              }
            });
          }
        }
      }
    );
  }
  handleBack() {
    const o = this.setDetailFormCache;
    const n = this.setDetailForm.item
      .map((item: any) => {
        return JSON.stringify(item);
      })
      .join("");
    if (o !== n) {
      this.$confirm(
        "当前页面有编辑内容未保存，返回后数据将丢失，且无法找回。",
        `返回 - 套餐列表`,
        {
          confirmButtonText: "确定",
          confirmButtonClass: "mwow-button-filled success mini",
          cancelButtonText: "取消",
          cancelButtonClass: "mwow-button-filled mini",
          type: "warning",
        }
      )
        .then(() => {
          this.$router.go(-1);
        })
        .catch(() => {});
    } else {
      this.$router.go(-1);
    }
  }
  handleSumInput(row: any) {
    row.sum = Number(this.handleInput(row.sum));
  }
  handleDiacountInput(row: any) {
    row.discount_amount = this.handleInput(row.discount_amount);
  }
  // 输入逻辑控制
  handleInput(val: any) {
    let n = String(val);
    if (n.includes("-")) {
      this.$message({
        message: "不能为负数",
        type: "error",
      });
      let i = n.indexOf("-");
      n = n.slice(i + 1);
    }
    let l = n.split(".");
    // 如果有小数，并且小数的位数大于2，将2位之后的数直接截掉
    if (l.length > 1 && l[1].length > 2) {
      l[1] = l[1].slice(0, 2);
      this.$message({
        message: "最多输入两位小数",
        type: "error",
      });
    }
    return l.join(".");
  }
  // 获焦暂停计算
  handleFocus() {
    this.blurStatus = false;
  }
  // 失焦计算
  handleBlur() {
    this.blurStatus = true;
  }
}
